import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class DQM {
  async getDQMInfoOnSource(Workspace_id, datasource, JobHistory_id) {
    const queryParams = JobHistory_id ? `?JobHistory_id=${JobHistory_id}` : ``;
    return (await fetchApi.get(`/data-modeling/${Workspace_id}/dqminfo/${datasource}${queryParams}`)).data;
  }

  async getDqmSourceData(Workspace_id, datasources) {
    return (
      await fetchApi.post(`/workspace/${Workspace_id}/dqm/datasource`, {
        datasources,
      })
    ).data;
  }

  async getDqmAttributeData(Workspace_id, dataSource, attributes) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/dqm/datasource/${dataSource}`, { attributes })).data;
  }

  async getDqmFields(Workspace_id, dataSource, JobHistory_id) {
    const queryParams = JobHistory_id ? `?JobHistory_id=${JobHistory_id}` : ``;
    return (await fetchApi.get(`/workspace/${Workspace_id}/dqm/datasource/dashboard/${dataSource}${queryParams}`)).data;
  }

  async getDqmFieldsSummary(Workspace_id, submitData) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/dqm/datasource/dashboard/summary`, submitData)).data;
  }

  async updateDqmRule(Workspace_id, DQMRule_id, updateData) {
    return (await fetchApi.patch(`/workspace/${Workspace_id}/dqm/${DQMRule_id}`, updateData)).data;
  }

  async updateAlertRecipients(Workspace_id, data) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/dqm/alert`, data)).data;
  }

  async getAlertRecipients(Workspace_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/dqm/alert`)).data;
  }

  async getFindingsQuery(Workspace_id, DQMRule_id, limit = 1000) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/dqm/getFindingsQuery/${DQMRule_id}?limit=${limit}`)).data;
  }
}
